export const getCookie = (cookieKey) => {
    let cookieValue = document.cookie.split("; ").find((row) => row.startsWith(`${cookieKey}=`));

    if (cookieValue) {
        cookieValue = cookieValue.split("=")[1];
    }

    return cookieValue;
};
